window._ = require('lodash');

window.device = require("current-device").default;

window.moment = require('moment-timezone');
window.moment.locale(data.locale);
window.moment.tz.setDefault(data.timezone);

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/* LIBRARIES */
require('jquery-countdown');

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();


var url = location.href.replace(/\/$/, "");

if (location.hash) {
    const hash = url.split("#");
    $('ul.nav a[href="#' + hash[1] + '"]').tab("show");
    url = location.href.replace(/\/#/, "#");
    history.replaceState(null, null, url);
    setTimeout(function () {
        $(window).scrollTop(0);
    }, 400);
}

$('a[data-toggle="tab"]').on("click", function () {
    var newUrl;
    const hash = $(this).attr("href");
    newUrl = url.split("#")[0] + hash;
    history.replaceState(null, null, newUrl);
});
